<template>
    <div class="rsv_color_info">
        {{ $t('reservationwindow.header.label_status') }} <v-icon small>mdi-alert-circle</v-icon>
        <ul class="list">
            <ReservationStateOverlayItem v-for="(state, index) in states" :key="index"
                :state="state"
                :palette="palette"/>
        </ul>
    </div>
</template>

<script>
import { sheetState } from '../../../sheet-state'
import { sheetFilters } from '../../../sheet-filters'
import ReservationStateOverlayItem from './ReservationStateOverlayItem.vue'

export default {
    components: { ReservationStateOverlayItem },
    props: {

    },
    data() {
        return {
            sheetState,
            sheetFilters
        }
    },
    watch: {
    },
    mounted() {
    },
    computed: {
        states: function() {
            return this.sheetFilters.states
        },
        palette: function() {
            return this.sheetState.reservationSetting?.statusColorPaletteID?.basicPalette ?? []
        }
    },
    methods: {
    }
}
</script>
